import React, { useContext, useEffect } from 'react';
import { Redirect, useParams } from 'react-router';

import { Container, Tabs } from 'components';
import { AuthContext, isOrgFeatureEnabled, useSpot } from 'framework';

import { LeaveRequests } from './user-info/leave-requests';
import { LeaveRemaining } from './user-info/leave-remaining';

export function Leave() {
  const { organization } = useParams<{ organization: string }>();
  const { getCurrentUser } = useContext(AuthContext);
  const { data, query } = useSpot();
  const id = getCurrentUser();
  const org = data?.organizations?.[organization];

  useEffect(() => {
    if (!org) {
      query(`org/${organization}`, {}, ['organizations', organization]);
    }
  }, [org, organization, query]);

  if (!org) {
    return <></>;
  }

  if (!isOrgFeatureEnabled(org, 'leave')) {
    return <Redirect to={`/${organization}`} />;
  }

  const tabs = {
    leaveRequests: <LeaveRequests id={id} organization={organization} />,
    leaveRemaining: <LeaveRemaining id={id} organization={organization} />
  };

  return (
    <Container>
      <Tabs tabs={tabs} />
    </Container>
  );
}
